import ProductListFilter, { ProductListFilterValues } from "../filter/ProductListFilter";
import { FilterSourceData } from "../filter/FilterValuesCollection";
import productListFiltersModalService from "../filter/ProductListFiltersModalService";
import ajaxClient from "../../../../js/common/AjaxClient";
import elementService from "@/common/ElementService";

interface ProductListResponse {
    readonly html: string;
    readonly filterData: FilterSourceData;
    readonly filter: ProductListFilterValues;
    readonly pageUrl: string;
    readonly page: number;
    readonly pagesCount: number;
    readonly orderBy: string | null;
    readonly browser: string;
}

export class ProductListLoaderEvent extends Event {
    public static readonly Type = "reload";

    constructor() {
        super(ProductListLoaderEvent.Type);
    }
}

export default new class ProductListLoaderService extends EventTarget {
    public async loadByFilter(currentFilter: ProductListFilter): Promise<void> {
        const response = await ajaxClient.post<ProductListResponse>("/Category/jsProductList", currentFilter.toJSON());

        this.actualizeContainersHTMLs(response);
        this.actualizeFilterSourceData(response.filterData);
        this.actualizeFilterProductsButtonVisibility();
        this.actualizeHashPart(currentFilter);

        this.dispatchEvent(new ProductListLoaderEvent());
    }

    private actualizeContainersHTMLs(response: ProductListResponse): void {
        const productListContainer = elementService.querySelector<HTMLDivElement>("#js-product-list-container");

        productListContainer.innerHTML = response.html;

        const isSelectedFilter = productListContainer.querySelector<HTMLDivElement>("#js-selected-filters-container") !== null;

        document.querySelector<HTMLButtonElement>(".js-filter-products-button")?.classList.toggle("hidden", isSelectedFilter);
        document.querySelector<HTMLButtonElement>(".js-open-category-watchdog-form")?.classList.toggle("pull-right", isSelectedFilter);
    }

    private actualizeFilterSourceData(filterData: FilterSourceData): void {
        productListFiltersModalService.setFilterData(filterData);
    }

    private actualizeFilterProductsButtonVisibility(): void {
        const hasSelectedFilters = document.querySelector<HTMLDivElement>("#js-selected-filters-container") !== null;

        for (const filterButton of document.querySelectorAll<HTMLButtonElement>(".js-filter-products-button")) {
            filterButton.classList.toggle("hidden", hasSelectedFilters);
        }

        for (const filterOpen of document.querySelectorAll<HTMLButtonElement>(".js-filter-open-check")) {
            filterOpen.classList.toggle("filters-on", hasSelectedFilters);
        }
    }

    private actualizeHashPart(currentFilter: ProductListFilter): void {
        globalThis.location.hash = JSON.stringify(currentFilter.toJSONForUrlHash());
    }
}();
